<template>
  <div>
    <h1 class="text-center">Store Master</h1>
    <div>
      <List />
    </div>
  </div>
</template>

<script>
import List from "./ListStore.vue";
export default {
  components: {
    List,
  },
};
</script>
